import store from '@/store'

export const checkRequireAuth = async (to, from, next) => {
  try {
    await store.dispatch('auth/validaLogado')
    if (!to.meta.requireAuth) console.log('!to.meta.requireAuth') // return next({ name: 'Default' })
    return next()
  } catch (e) {
    if (to.meta.requireAuth) return next({ name: 'Login', query: { redirect: to.fullPath } })
    return next()
  }
}



// WEBPACK FOOTER //
// ./src/router/meta/requireAuth.js